import { useCurrentStore } from "../states";
import { v4 as uuidv4 } from "uuid";

export const getSponsoredProducts = (
	user: any,
	pageType: string,
	optionals?: {
		articleSKUs?: Array<string>;
		searchWord?: String;
		categoryId?: string[];
		brands?: Array<string>;
	}
) => {
	let sessionID = useCookie("cookieIdentifier", { default: () => "c_" + (user?.sessionIdentifier ?? uuidv4()) }).value;
	setABContextVariable('ip', useRequestHeaders()["x-sponso-ip"])

	let sponsoRequest = {
		sessionIdentifier: sessionID,
		customerId: user?.roles?.[0] != "ANONYMOUS" ? user?.userId : undefined, // if UserStatus.ACTIVE
		email: user?.roles?.[0] != "ANONYMOUS" ? user?.addresses[0]?.email : undefined, // UserStatus.ACTIVE
		pageType: pageType,
		mobile: useDevice()?.isMobile,
		institutionId: useCurrentStore()?.value?.id,
		categories: optionals?.categoryId,
		articleSKUs: optionals?.articleSKUs?.slice(0, 10),
		filters: {
			brand: optionals?.brands,
		},
		consented: true,
		gdprApplies: true,
		clientIp: useRequestHeaders()["x-sponso-ip"],
		listSize: optionals?.searchWord ? 2 : 5,
		userAgent: useDevice().userAgent,
		searchWord: optionals?.searchWord,
		pageNumber: optionals?.searchWord ? 1 : undefined,
	};

	if(sponsoRequest.pageType == 'CATEGORY' && sponsoRequest.searchWord){
		sponsoRequest.searchWord = undefined;
		sponsoRequest.pageNumber = undefined;
	}
	console.debug("[bt-expSponsoredProducts] requesting", sponsoRequest);
	return useFetch(useRuntimeConfig().public.apiUrl + "/api/sponsoring-service/requestProducts", {
      method: "POST",
      body: {
			request: sponsoRequest,
		}, watch: [useRoute()],
		onResponse({ response }) {
			try {
				const articles = [];
				if (response?._data != null && response?._data?.articles != null) {
					for (const article of response?._data?.articles) {
						articles.push(article);
					}
				}
                if (import.meta.client) {
                    $fetch('/api/sponsoring-service/sponsoredReceived', {
                        method: 'POST',
                        body: {
                        pageType: sponsoRequest?.pageType,
                        device: sponsoRequest?.mobile ? 'mobile' : 'desktop',
                        count: articles?.length || 0,
                        type: 'received'
                        }
                    });
                }
                
			} catch (e) {
			console.warn('metrics failed', e);
			}
            
		}
    }
	);
};
